import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetResultsSection, WorksheetRootComponent } from 'Components/Worksheets/Core';
import { PageSection } from '../../Layout';
import qestIds from '../QestIds';
import { MeasurementsSection, PreparationSection, ResultsSection } from './InHouseMethod/Sections';

let McvEmbeddedHandShearVaneWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>

      <PageSection heading="Measurements">
        <MeasurementsSection showEmbeddedTestFields />
      </PageSection>

      <WorksheetResultsSection heading="Results">
        <ResultsSection />
      </WorksheetResultsSection>
    </>
  );
};

McvEmbeddedHandShearVaneWorksheet = withInjectedProps(McvEmbeddedHandShearVaneWorksheet);
McvEmbeddedHandShearVaneWorksheet.qestIds = [qestIds.handShearVane.InHouseMethod];

export default McvEmbeddedHandShearVaneWorksheet;
export { McvEmbeddedHandShearVaneWorksheet };
